import React from 'react';
import { Link } from 'react-router-dom';
import type { Lang } from '../../types/funnel';
import { legalLinkLabels, legalPaths } from '../../data/business';
interface LegalLinksProps {
  lang: Lang;
  /** Open in a new tab so an in-progress form is not interrupted. */
  newTab?: boolean;
  className?: string;
}
export function LegalLinks({
  lang,
  newTab = false,
  className = ''
}: LegalLinksProps) {
  const cls = 'inline-flex min-h-[44px] items-center font-semibold underline underline-offset-4 hover:text-ink sm:min-h-0';
  const links = [{
    to: legalPaths.privacy,
    label: legalLinkLabels.privacy[lang]
  }, {
    to: legalPaths.terms,
    label: legalLinkLabels.terms[lang]
  }];
  return <p className={`flex flex-wrap items-center gap-x-4 gap-y-0 ${className}`} data-id="element-1086" data-mp="vsbnyzwl7jpf">
      {links.map(l => newTab ? <a key={l.to} href={l.to} target="_blank" rel="noopener" className={cls} data-id="element-1087" data-mp="2v3l9nyo8cyx3">
            {l.label}
          </a> : <Link key={l.to} to={l.to} className={cls} data-id="element-1088" data-mp="2q3yuhjoud8ln">
            {l.label}
          </Link>)}
    </p>;
}